module.exports = __webpack_public_path__ + "media/images/illustration/undraw_best_place_r685-824cfc181e45b38b47543b230afe664e.svg";